import { render, staticRenderFns } from "./wbjkZlv.vue?vue&type=template&id=779d80f4&scoped=true"
import script from "./wbjkZlv.vue?vue&type=script&lang=js"
export * from "./wbjkZlv.vue?vue&type=script&lang=js"
import style0 from "./wbjkZlv.vue?vue&type=style&index=0&id=779d80f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779d80f4",
  null
  
)

export default component.exports